/**
 * Created by sailengsi on 2017/5/10.
 */

// user
export const UPDATE_USERINFO = 'UPDATE_USERINFO'
export const REMOVE_USERINFO = 'REMOVE_USERINFO'
export const UPDATE_REMUMBER = 'UPDATE_REMUMBER'
export const REMOVE_REMUMBER = 'REMOVE_REMUMBER'

//tabs
export const REMOVE_TABS = 'REMOVE_TABS'
export const UPDATE_TABS = 'UPDATE_TABS'
export const CLEAR_TABS = 'CLEAR_TABS'





// WEBPACK FOOTER //
// ./src/store/modules/mutations_types.js